module.exports = __webpack_public_path__ + "img/GasbotSideLeft.485698da.webp";